module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/awesome-typescript-loader/dist/entry.js?silent=true!./new-estimate-popup.ts"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./ClientApp/components/new-estimate-popup/new-estimate-popup.ts
// module id = 91
// module chunks = 53